// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__6qPMe","truncatedText":"styles_truncatedText__aqFKs","fullText":"styles_fullText__4YJjv","textContainer":"styles_textContainer__5H6E_"};